"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessorSchema = exports.ReportingPeriodParameterConfigSchema = exports.FormulaParameterConfigSchema = exports.Methods = void 0;
const _imports_1 = require("../../_imports");
const _shared_1 = require("../../_shared");
exports.Methods = [
    'accruedLiabilities',
    'backupServicingCycleMetrics',
    'borrowingBaseMetrics',
    'creditAgreementMetrics',
    'fundingRequestMetrics',
    'invoiceMetrics',
    'loanMetrics',
    'orgProvidedInputs',
    'portfolioCovenantResults',
    'financialCovenantResults',
];
/**
 * These basically represent pointer methods to existing domain controller / accessors
 */
// Zod schemas for DataAccessor types
exports.FormulaParameterConfigSchema = _imports_1.z.object({
    type: _imports_1.z.literal('formula'),
    params: _shared_1.FormulaConfigSchema,
});
exports.ReportingPeriodParameterConfigSchema = _imports_1.z.object({
    type: _imports_1.z.literal('reportingPeriod'),
    params: _imports_1.ReportingPeriod.ReportingPeriodSchema,
});
// Config schemas for each accessor type
const AccruedLiabilitiesConfigSchema = _imports_1.z.object({
    startDateFormula: exports.FormulaParameterConfigSchema,
    endDateFormula: exports.FormulaParameterConfigSchema,
    requiresLatestStatementForPeriod: _imports_1.z.boolean().optional(),
});
const BorrowingBaseMetricsConfigSchema = _imports_1.z.object({
    reportingDateFormula: exports.FormulaParameterConfigSchema,
    reportingPeriod: exports.ReportingPeriodParameterConfigSchema,
});
const FundingRequestMetricsConfigSchema = _imports_1.z.object({
    reportingDateFormula: exports.FormulaParameterConfigSchema,
    reportingPeriod: exports.ReportingPeriodParameterConfigSchema,
});
const OrgProvidedInputsConfigSchema = _imports_1.z.object({
    reportingDateFormula: exports.FormulaParameterConfigSchema,
    reportingPeriod: exports.ReportingPeriodParameterConfigSchema,
});
const PortfolioCovenantResultsConfigSchema = _imports_1.z.object({
    reportingDateFormula: exports.FormulaParameterConfigSchema,
    reportingPeriod: exports.ReportingPeriodParameterConfigSchema,
});
const FinancialCovenantResultsConfigSchema = _imports_1.z.object({
    reportingDateFormula: exports.FormulaParameterConfigSchema,
    reportingPeriod: exports.ReportingPeriodParameterConfigSchema,
});
// Accessor schemas
const AccruedLiabilitiesAccessorSchema = _imports_1.z.object({
    method: _imports_1.z.literal('accruedLiabilities'),
    name: _imports_1.z.string(),
    variables: _imports_1.z.array(_shared_1.QueryVariableSchema),
    parameterConfig: AccruedLiabilitiesConfigSchema,
});
const BorrowingBaseMetricsAccessorSchema = _imports_1.z.object({
    method: _imports_1.z.literal('borrowingBaseMetrics'),
    name: _imports_1.z.string(),
    variables: _imports_1.z.array(_shared_1.QueryVariableSchema),
    parameterConfig: BorrowingBaseMetricsConfigSchema,
});
const BackupServicingCycleMetricsAccessorSchema = _imports_1.z.object({
    method: _imports_1.z.literal('backupServicingCycleMetrics'),
    name: _imports_1.z.string(),
    variables: _imports_1.z.array(_shared_1.QueryVariableSchema),
    // This accessor has no parameter config. `.default(null)` accepts the key being
    // absent (coercing to null) while keeping the inferred type `null`, so it
    // survives the credit-agreement document translation, which drops nil values
    // (`swapEntitiesForIds`): an authored `null` becomes an absent key by the time
    // the document is validated. Without this, a backupServicingCertificate report
    // property cannot be committed through the normal CA WIP → commit path (only
    // via a raw document write).
    parameterConfig: _imports_1.z.null().default(null),
});
const CreditAgreementMetricsAccessorSchema = _imports_1.z.object({
    method: _imports_1.z.literal('creditAgreementMetrics'),
    name: _imports_1.z.string(),
    variables: _imports_1.z.array(_shared_1.QueryVariableSchema),
    parameterConfig: _imports_1.z.null(),
});
const InvoiceMetricsAccessorSchema = _imports_1.z.object({
    method: _imports_1.z.literal('invoiceMetrics'),
    name: _imports_1.z.string(),
    variables: _imports_1.z.array(_shared_1.QueryVariableSchema),
    parameterConfig: _imports_1.z.null(),
});
const LoanMetricsAccessorSchema = _imports_1.z.object({
    method: _imports_1.z.literal('loanMetrics'),
    name: _imports_1.z.string(),
    variables: _imports_1.z.array(_shared_1.QueryVariableSchema),
    parameterConfig: _imports_1.z.null(),
});
const FundingRequestMetricsAccessorSchema = _imports_1.z.object({
    method: _imports_1.z.literal('fundingRequestMetrics'),
    name: _imports_1.z.string(),
    variables: _imports_1.z.array(_shared_1.QueryVariableSchema),
    parameterConfig: FundingRequestMetricsConfigSchema,
});
const OrgProvidedInputsAccessorSchema = _imports_1.z.object({
    method: _imports_1.z.literal('orgProvidedInputs'),
    name: _imports_1.z.string(),
    variables: _imports_1.z.array(_shared_1.QueryVariableSchema),
    parameterConfig: OrgProvidedInputsConfigSchema,
});
const PortfolioCovenantResultsAccessorSchema = _imports_1.z.object({
    method: _imports_1.z.literal('portfolioCovenantResults'),
    name: _imports_1.z.string(),
    variables: _imports_1.z.array(_shared_1.QueryVariableSchema),
    parameterConfig: PortfolioCovenantResultsConfigSchema,
});
const FinancialCovenantResultsAccessorSchema = _imports_1.z.object({
    method: _imports_1.z.literal('financialCovenantResults'),
    name: _imports_1.z.string(),
    variables: _imports_1.z.array(_shared_1.QueryVariableSchema),
    parameterConfig: FinancialCovenantResultsConfigSchema,
});
exports.AccessorSchema = _imports_1.z.discriminatedUnion('method', [
    AccruedLiabilitiesAccessorSchema,
    BackupServicingCycleMetricsAccessorSchema,
    BorrowingBaseMetricsAccessorSchema,
    CreditAgreementMetricsAccessorSchema,
    InvoiceMetricsAccessorSchema,
    LoanMetricsAccessorSchema,
    FundingRequestMetricsAccessorSchema,
    OrgProvidedInputsAccessorSchema,
    PortfolioCovenantResultsAccessorSchema,
    FinancialCovenantResultsAccessorSchema,
]);
//# sourceMappingURL=DataAccessor.js.map